export enum RespiratoryConstant {
  NOT_IMPLEMENTED = 'Respiratory/NOT_IMPLEMENTED',
  SET_BREATHSOUNDS_LEFT = 'Respiratory/SET_BREATHSOUNDS_LEFT',
  SET_BREATHSOUNDS_RIGHT = 'Respiratory/SET_BREATHSOUNDS_RIGHT',
  SET_BREATHSOUNDS_COMMENT = 'Respiratory/SET_BREATHSOUNDS_COMMENT',
  SET_RESPIRATORY_EFFORT = 'Respiratory/SET_RESPIRATORY_EFFORT',
  SET_O2 = 'Respiratory/SET_O2',
  SET_RFIO2 = 'Respiratory/SET_RFIO2',
  SET_FIO2AirTemp = 'Respiratory/SET_FIO2AirTemp',
  SET_FIO2Humidity = 'Respiratory/SET_FIO2Humidity',
  SET_VIA = 'Respiratory/SET_VIA',
  SET_PERFORMEDBY = 'Respiratory/SET_PERFORMEDBY',
  SET_OUTCOME = 'Respiratory/SET_OUTCOME',
  SET_RESP_COMMENT = 'Respiratory/SET_RESP_COMMENT',
  SET_RESP_EXAM = 'Respiratory/SET_RESP_EXAM',
  SET_RESPIRATORY = 'Respiratory/SET_RESPIRATORY',
  SAVE_RESPIRATORY = 'Respiratory/SAVE_RESPIRATORY',
  RESET_STATE = 'Respiratory/RESET_STATE',
  SET_FIO2AirTemp_UNIT = 'Respiratory/SET_FIO2AirTemp_UNIT',
}
